import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import { useGetProjectsByDropDownQuery } from "slices/projects/projectSlice";

// Define status options based on your Django model
const STATUS_OPTIONS = [
  { id: "draft", status_name: "Draft" },
  { id: "submitted", status_name: "Submitted" },
  { id: "cancelled", status_name: "Cancelled" },
];

export const PurchaseRequestGlobalFilter = ({ setPageState, globalValue }: any) => {
    
  const { data: Projects } = useGetProjectsByDropDownQuery(undefined);

  const [dateRange, setDateRange] = useState([null, null]);

  const statusOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      status: value,
      page: 1,
    }));
  };

  const projectsOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      project: value,
      page: 1,
    }));
  };

  // If you want to use the commented date functionality later
  // const handleDateChange = (selectedDates: any) => {
  //   if (selectedDates.length === 2) {
  //     const [startDate, endDate] = selectedDates;
  //     setDateRange([startDate, endDate]);

  //     let startDateString = startDate.toISOString().split("T")[0];
  //     let dueDateString = endDate.toISOString().split("T")[0];

  //     setPageState((prev: any) => ({
  //       ...prev,
  //       start_date: startDateString,
  //       end_date: dueDateString,
  //     }));
  //   }
  // };

  return (
    <React.Fragment>
      {/* <div className="col-xxl-3 col-sm-3">
         <Flatpickr
          placeholder="Select start & due date range"
          className="form-control bg-light border-light"
          options={{
            mode: "range",
            dateFormat: "d-m-Y",
          }}
          value={dateRange}
          onChange={handleDateChange}
        /> 
      </div> */}

      <div className="col-xxl-3 col-sm-3">
        <div className="input-light">
          <select
            onChange={(e) => statusOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="status"
            id="idStatus"
          >
            <option value="" className="text-muted">
              All Status
            </option>
            {STATUS_OPTIONS?.map((options: any) => (
              <option key={options.id} value={options.id}>
                {options.status_name}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="col-xxl-3 col-sm-3">
        <div className="input-light">
          <select
            onChange={(e) => projectsOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="status"
            id="idStatus"
          >
            <option value="">All Projects</option>
            {Projects?.map((options: any) => (
              <option key={options?.id} value={options?.id}>
                {options.project_name} ({options.project_short_name})
              </option>
            ))}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
};